import { render, staticRenderFns } from "./LastestNFT.vue?vue&type=template&id=b156464a"
import script from "./LastestNFT.vue?vue&type=script&lang=js"
export * from "./LastestNFT.vue?vue&type=script&lang=js"
import style0 from "./LastestNFT.vue?vue&type=style&index=0&id=b156464a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports